import { CLINICAL_BASE_PATH } from '../constants';

export const GENERIC_HEALTH_HISTORY_SHOW_PATH = `${CLINICAL_BASE_PATH}/support/generic-health-history/show/:id`;
export const GENERIC_HEALTH_HISTORY_FIND_PATH = `${CLINICAL_BASE_PATH}/support/generic-health-history/find`;
